{
  "footer": {
    "copyright": "© 2026 Ef Es Academy Ltd. ⋅ <PrivacyPolicy>Privacy Policy</PrivacyPolicy>"
  },
  "nav": {
    "about-us": "About Us",
    "contacts": "Contacts",
    "home": "Home",
    "services": "Services",
    "solutions": "Solutions"
  },
  "privacy-policy-url": "/legal/privacy-policy/latest-en",
  "sec1": {
    "button-employee-login": "Employee Login",
    "button-manager-login": "Manager Login",
    "open-in": "Open in",
    "title1": "Digital Transformation of Food Safety",
    "title2": "Paperless. Everything on Your Phone."
  },
  "sec2": {
    "left": {
      "item1": "Digital platform for incoming control and checklists",
      "item2": "Online food safety training for employees",
      "item3": "Electronic document archive",
      "item4": "Consultations for opening a facility",
      "item5": "HACCP documentation",
      "item6": "Internal inspections and audits",
      "title": "Our Solutions"
    },
    "right": {
      "item1": "Paperless – Everything on your phone",
      "item2": "Video lessons and tests organized by position and level – easy and effective",
      "item3": "Automatic reminders for expiring deadlines",
      "item4": "Time and resource savings",
      "item5": "Easy integration into daily tasks",
      "item6": "Created by consultants with years of food safety experience",
      "title": "Advantages"
    }
  },
  "sec3": {
    "service1": {
      "item1": "User-friendly interface that drastically reduces filling time",
      "item10": "Administrative panel for centralized control",
      "item2": "AI – Monitoring of control cards",
      "item3": "Detection of errors, missing values, and unrealistic data",
      "item4": "Intelligent data analysis to enhance safety",
      "item5": "Reports and recommendations for improvement",
      "item6": "Increased transparency and traceability",
      "item7": "Setting deadlines for completion",
      "item8": "Quick access to completed control cards during inspection",
      "item9": "Reliable archive of completed control cards",
      "subtitle": "Simplified control card completion directly from your smartphone",
      "title": "Electronic Control Cards"
    },
    "title": "Services"
  },
  "sec5": {
    "consulting": {
      "group1": {
        "item1": "Objective assessment and real insight into the condition of the site",
        "item2": "On-site inspections using approved checklists",
        "item3": "Photo materials and specific recommendations",
        "item4": "Comparison between actual condition and system records",
        "item5": "Report with analysis and recommendations to the owner/manager",
        "title": "Internal Inspections"
      },
      "group2": {
        "item1": "Professional assistance from day one",
        "item2": "Preparation for initial registration",
        "item3": "Review of technological projects and process flows",
        "title": "Consultations for Opening a Food Facility"
      },
      "group3": {
        "item1": "Complete set of documents ready for practical application",
        "item2": "Development and implementation of HACCP plan",
        "item3": "Updating documentation upon changes",
        "title": "Documentation and HACCP"
      },
      "link": "Learn more at <Link>fsconsulting.bg</Link>",
      "subtitle": "For seamless operation of a food facility"
    },
    "organizer": {
      "item1": "Controlled employee access to documents",
      "item2": "Ability to add reminders for updating expiring documents with a deadline",
      "item3": "Reliable document storage",
      "subtitle": "Digital archive of all important organizational documents by institution"
    },
    "service2": {
      "item1": "Directly add documents using the phone camera into a secure cloud space without loading its memory",
      "item2": "Ability for multiple employees to work simultaneously – employee, clerk, accountant, control body",
      "item3": "Review, share, or print already created documents",
      "item4": "Search and filter documents by specified criteria",
      "subtitle": "Saves time and effort on manual processing of accompanying documents",
      "title": "Incoming Control"
    },
    "subtitle1": "Consulting Services",
    "subtitle4": "Organizer",
    "training": {
      "item1": "Systematized and up-to-date content – over 130 pages of material in 10 video lessons of about 20 minutes each",
      "item2": "Meets high global standards for quality and teaching effectiveness",
      "item3": "Test form for knowledge verification",
      "item4": "Easily organize training according to the needs and positions of employees",
      "item5": "Option to plan refresher training through the platform calendar",
      "item7": "The course is certified by <Cpd>The CPD Certification Service</Cpd> – a leading international organization for the accreditation of Continuing Professional Development (CPD) training.",
      "subtitle": "Replaces lecture format with modern and engaging multimedia training",
      "subtitle1": "Food Safety Training"
    }
  },
  "sec6": {
    "p1": "Food Safety Academy was created with one clear mission – to make food safety real practice, not just a document. We believe that quality and safe food is the result of knowledge applied daily – not only during inspections but every working day, by every team member.",
    "p2": "Our products and training are developed to unite theory with real experience from the professional kitchen and control practice. They give people the confidence to work properly, and business – peace of mind and traceability.",
    "p3": "We know that in an environment where compromises are often made, true professionalism begins with personal responsibility. Therefore, our team creates solutions that help companies build a safety culture – based on knowledge, transparency, and real actions.",
    "p4": "Food Safety Academy – because it matters.",
    "title": "About Us",
    "video": {
      "alt": "Still from the “Na Kafe” TV show featuring Food Safety Academy"
    }
  },
  "sec7": {
    "demo": "For a 10-minute demo",
    "email": "Email: <Email/>",
    "phone": "Phone: <Phone/>",
    "title": "Contact Us"
  },
  "sec8": {
    "subtitle": "Join the team",
    "text": "If you want to participate in spreading this platform, contact us for more information at <Email/> with the subject <strong>Distribution</strong>",
    "title": "Careers"
  },
  "subtitle": "Digital Platform for Food Safety",
  "title": "Food Safety Academy",
  "youtube": {
    "caption": "Watch the video on YouTube (opens in a new tab)"
  }
}
